import { BaseService } from '../../infra/base.service'
import type { RecurringBillEntity } from './recurring-bill'
import type { RecurringBillsRepository } from './recurring-bills.repository'

export class RecurringBillsService extends BaseService<RecurringBillEntity> {
    constructor(private rep: RecurringBillsRepository) {
        super(rep)
    }
}
